import { useRegulationsCheck } from '@/hooks/useRegulationsCheck'
import RegulationsModal from '@/modals/RegulationsModal'
import React, { createContext, ReactNode, useContext, useMemo } from 'react'

interface RegulationsContextValue {
    isRegulationsBlocking: boolean
}

const RegulationsContext = createContext<RegulationsContextValue>({
    isRegulationsBlocking: false,
})

export const useRegulations = () => useContext(RegulationsContext)

interface RegulationsProviderProps {
    children: ReactNode
}

export const RegulationsProvider: React.FC<RegulationsProviderProps> = ({
    children,
}) => {
    const { shouldShowRegulations, regulationData, isLoading } =
        useRegulationsCheck()

    // Memoize context value to prevent unnecessary re-renders
    const contextValue = useMemo(
        () => ({ isRegulationsBlocking: shouldShowRegulations }),
        [shouldShowRegulations]
    )

    // Show modal overlay without blocking children render
    const showModal = !isLoading && shouldShowRegulations && !!regulationData

    return (
        <RegulationsContext.Provider value={contextValue}>
            {children}

            {showModal && <RegulationsModal regulation={regulationData} />}
        </RegulationsContext.Provider>
    )
}
